<div class="legals-notices-wrapper" [ngClass]="{ active: collapsedLegals }">
    @if (legalsLoaded) {
        <div class="expand-wrap legals-notices">
            <div class="icon-arrow-wrapper" (click)="collapsedLegals = !collapsedLegals">
                <i class="icon-item">
                    <span
                        btlSvg
                        file="fai-results-defs"
                        title="check"
                        name="shape-icon-arrow-d"
                        class="s-arrow-d"
                    ></span>
                </i>
            </div>
            <h3 class="legals-notices-title">{{ title }}</h3>
        </div>
    }
    <div class="content">
        <btl-cms-block
            [blockId]="blockId"
            (contentIsLoaded)="mentionLoaded($event)"
            [battlefront]="false"
        ></btl-cms-block>
    </div>
</div>
